'use client';

import { useEffect, useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const stats = [
  { id: 'stat_impressions', value: '20M+', label: 'Total Overall Impressions', icon: 'ChartBarIcon' },
  { id: 'stat_partnerships', value: '20+', label: 'Brand Partnerships', icon: 'SparklesIcon' },
  { id: 'stat_published', value: 'Age 15', label: 'PUBLISHED RESEARCHER ', icon: 'AcademicCapIcon' }];


  return (
    <section className="relative min-h-screen flex items-end pt-32 pb-20 px-6 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src="/assets/images/kiddos-1774394758172.png"
          alt="Mary Bellakbira giving high-fives to children in a classroom setting"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/45 to-black/15"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto w-full">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>

          {/* Name */}
          <h1 className="font-display text-7xl md:text-9xl font-light text-white mb-3 tracking-tight leading-none italic">
            Mary <br />
            <span className="not-italic font-semibold text-white">Bellakbira</span>
          </h1>

          {/* Primary Role Line */}
          <p className="text-base md:text-lg text-white/90 font-light tracking-widest uppercase mb-6 max-w-3xl">
            Co-Founder &amp; Director of Operations &amp; Partnerships,&nbsp;
            <span className="text-accent font-medium">Food For Thought Foundation</span>
            &nbsp;·&nbsp;Founder of&nbsp;
            <span className="text-accent font-medium">Hormolize</span>
          </p>

          {/* Divider */}
          <div className="w-16 h-px bg-white/40 mb-6"></div>

          {/* Identity Tags */}
          <div className="flex flex-wrap gap-x-5 gap-y-2 mb-5 max-w-2xl">
            {['Nonprofit Founder & Entrepreneur', 'Health Advocate', 'Dynamic Vocalist', 'Published Researcher'].map((tag) => (
              <span key={tag} className="text-sm md:text-base text-white/80 font-light tracking-wide">
                {tag}
              </span>
            ))}
          </div>

          {/* Personal Note */}
          <p className="text-sm text-yellow-300/90 font-light italic mb-5 tracking-wide">
            Most importantly: sister, daughter &amp; friend
          </p>

          {/* Intersections Line */}
          <p className="text-sm md:text-base text-white/60 font-light tracking-widest uppercase mb-12">
            At the intersections of&nbsp;
            <span className="text-white/80">Healthcare · STEM · Business · Arts · Advocacy · Media</span>
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-16 items-center">
            <a
              href="/contact"
              className="px-8 py-4 bg-white text-foreground rounded-full font-medium text-xs uppercase tracking-[0.15em] hover:bg-accent hover:text-white transition-all duration-400 shadow-lg hover-lift">
              Book Mary to Speak
            </a>
            <a
              href="https://www.linkedin.com/in/maryambellakbira/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="flex items-center gap-2 px-6 py-4 bg-[#0A66C2] text-white rounded-full font-medium text-xs uppercase tracking-[0.15em] hover:bg-[#004182] transition-all duration-400 shadow-lg hover-lift">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
              LinkedIn
            </a>
          </div>
        </div>

        {/* Floating Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl">
          {stats.map((stat, index) =>
          <div
            key={stat.id}
            className={`bg-white/90 backdrop-blur-md p-6 rounded-2xl shadow-xl border border-white/50 transition-all duration-700 hover-reveal-border hover-shimmer ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`
            }
            style={{ transitionDelay: `${index * 200}ms` }}>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-foreground/5 rounded-xl">
                  <Icon name={stat.icon as any} size={24} className="text-foreground" />
                </div>
                <div>
                  <p className="font-display text-3xl font-semibold text-foreground mb-1">{stat.value}</p>
                  <p className="text-xs text-foreground/60 tracking-wide uppercase">{stat.label}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}